// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"edd46d8a","732":"604b564e","977":"b4ccdbfa"}[chunkId] + ".chunk.js");